import { UserState } from "./types";

const all = (state: UserState) => state.user;

const token = (state: UserState) => all(state).token;

export const userSelectors = {
  token,
};
